module.exports = __webpack_public_path__ + "img/reserve_phone_icon.51cf176d.svg";